import { useEffect } from "react";
import { TooltipGroup } from "./TooltipGroup";
import { TourLauncher } from "./TourLauncher";
import { useRouteTooltipGroupKey } from "./useRouteTooltipGroup";
import { hydrateTooltipPrefs } from "./prefs";
import { useAuth } from "@/contexts/AuthContext";

/**
 * App-shell mount: resolves the tooltip group for the current route and runs
 * its walkthrough / hover tips, plus the manual tour launcher.
 */
export function RouteTooltips() {
  const groupKey = useRouteTooltipGroupKey();
  const { user, isLoading } = useAuth();

  // Pull the account's stored preferences before any tour can auto-start.
  useEffect(() => {
    if (isLoading) return;
    void hydrateTooltipPrefs(user?.id ?? null);
  }, [user?.id, isLoading]);

  if (!groupKey) return null;
  return (
    <>
      <TooltipGroup key={groupKey} groupKey={groupKey} />
      <TourLauncher groupKey={groupKey} />
    </>
  );
}


export default RouteTooltips;
